/**
 * Qué formas de entrar están realmente activadas.
 *
 * Por qué existe: la pantalla de acceso mostraba "Continuar con Google"
 * aunque Google nunca se activó en el panel de Supabase. Quien lo tocaba
 * no entraba: aterrizaba en una página en blanco con un texto en inglés
 * —"provider is not enabled"— sin forma de volver. Un botón que falla
 * siempre espanta más gente que no tener el botón.
 *
 * En vez de borrarlo a mano y tener que acordarse de traerlo de vuelta,
 * se le pregunta al servidor qué hay activado y se muestra solo eso. El
 * día que se active Google en el panel, el botón aparece solo, sin tocar
 * el código ni volver a publicar.
 *
 * Si la consulta falla (sin internet, por ejemplo) no se muestra ningún
 * botón social: es mejor que falte una opción a que aparezca una rota.
 */

const URL_BASE = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const CLAVE = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

export interface ProveedoresActivados {
  google: boolean;
  facebook: boolean;
  apple: boolean;
}

const NINGUNO: ProveedoresActivados = { google: false, facebook: false, apple: false };

export async function proveedoresActivados(): Promise<ProveedoresActivados> {
  try {
    const respuesta = await fetch(`${URL_BASE}/auth/v1/settings`, {
      headers: { apikey: CLAVE },
    });
    if (!respuesta.ok) return NINGUNO;

    const datos = await respuesta.json();
    const externos = datos?.external ?? {};

    return {
      google: Boolean(externos.google),
      facebook: Boolean(externos.facebook),
      apple: Boolean(externos.apple),
    };
  } catch (error) {
    console.error('No se pudo saber qué formas de entrar están activadas:', error);
    return NINGUNO;
  }
}
